import { createSelector } from 'reselect';
import { ITEMS_PER_PAGE, suggestModalReducerKey } from './SuggestModalConstants';

export const suggestModal = (state) => {
  return state.get(suggestModalReducerKey);
};

export const isLoading = (state) => {
  return suggestModal(state).get('isLoading');
};

export const isNextPageLoading = (state) => {
  return suggestModal(state).get('isNextPageLoading');
};

export const opModel = (state) => {
  return suggestModal(state).get('opModel');
};

export const noData = (state) => {
  return suggestModal(state).get('noData');
};

export const currentDB = (state) => {
  return suggestModal(state).get('currentDB');
};

export const highlightedItem = (state) => {
  return suggestModal(state).get('highlightedItem');
};

export const currentPage = (state) => {
  return suggestModal(state).get('currentPage');
};

export const expandedValue = (state) => {
  return suggestModal(state).get('expandedValue');
};

export const fullUpdate = (state) => {
  return suggestModal(state).get('fullUpdate');
};

export const suggestConfig = (state) => {
  return suggestModal(state).get('suggestConfig');
};

// eslint-disable-next-line no-shadow
export const maxPage = createSelector([opModel], (opModel) => {
  return Math.ceil(opModel.groupCount / ITEMS_PER_PAGE);
});
